module.exports = __webpack_public_path__ + "static/img/audio_pic5.792cd9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/audio_pic5.png
// module id = yxM/
// module chunks = 0